import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import CopyPasteProblem from "../components/CopyPasteProblem";
import AddProblemByName from "../components/AddProblemByName";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const AddProblemPage = () => {
  const [role, setRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRole = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setRole("FREE_USER");
        setIsLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        const userId = decoded.id;

        const res = await axios.get(`${baseUrl}/users/account/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setRole(res.data.role || "FREE_USER");
      } catch (err) {
        console.error("❌ Failed to fetch user role:", err);
        setRole("FREE_USER");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRole();
  }, []);

  if (isLoading) {
    return <div style={{ textAlign: "center", marginTop: "100px" }}>Loading...</div>;
  }

  const isFreeUser = role === "FREE_USER";
  const isPaidUser = role === "PAID_USER";
  const isPremiumOrAdmin = ["PREMIUM_USER", "ADMIN"].includes(role);

  return (
    <div style={{ padding: "20px" }}>
      {isFreeUser ? (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <h2>This feature is for paid users only.</h2>
          <p>Upgrade your membership to access the problem importer.</p>
          <button
            className="upgrade-button"
            style={{
              padding: "10px 20px",
              fontSize: "1.1rem",
              marginTop: "20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={() => navigate("/membership")}
          >
            Upgrade Now
          </button>
        </div>
      ) : (
        <>
          {isPaidUser && (
            <div
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                color: "#856404",
                padding: "12px 20px",
                borderRadius: "6px",
                marginBottom: "20px",
                fontSize: "1rem",
              }}
            >
              <strong>Note:</strong> You have 1 free import per month.{" "}
              <span
                style={{ color: "#007bff", cursor: "pointer" }}
                onClick={() => navigate("/membership")}
              >
                Upgrade to get more!
              </span>
            </div>
          )}
          <CopyPasteProblem />
          {/* Optional: <AddProblemByName /> */}
        </>
      )}
    </div>
  );
};

export default AddProblemPage;
